import React, { useContext, useEffect, useState } from "react";
import {
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
// import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polygon, Polyline, InfoWindow } from "react-google-maps";
import { Navbar } from "./../components/Template/NavBar";
import { ProgramarSalida } from "../pages/landing/ProgramarSalida";
import { EnRuta } from "../pages/landing/EnRuta";
import { AuthContext } from "../context/authContext/authContext";
import { RutaNoExistente } from "../pages/landing/RutaNoExistente";
import { Bitacora } from "../pages/bitacora/Bitacora";
import { GeneracionCodigos } from "../pages/Admin/GeneracionCodigos";
import { TableroGerencial } from "../pages/Admin/TableroGerencial";
import { Test } from "../pages/Test";
import { Tablero } from "../pages/landing/Tablero";
import { TableroTripulantes } from "../pages/Admin/TableroTripulantes";
import { TableroCedis } from "../pages/Admin/TableroCedis";
import { TableroUnidades } from "../pages/Admin/TableroUnidades";
import { Staffing } from "../pages/Admin/Staffing";
import { TableroUsuarios } from "../pages/Admin/TableroUsuarios";
import { TableroTiendas } from "../pages/Admin/TableroTiendas";
import { SelectCedis } from "../pages/Account/SelectCedis";
import { BitacoraAdministracion } from "../pages/Admin/BitacoraAdministracion";
import { WhatsappBotNotification } from "../components/customComponents/WhatsappBot/WhatsappBotNotification";
import { Historico } from "../pages/notificaciones/Historico";
import { AdministracionStatusEnRuta } from "../pages/Admin/AdministracionStatusEnRuta";
import { AdministracionEdicionViajes } from "../pages/Admin/AdministracionEdicionViajes";
import { AdministracionProtocolos } from "../pages/Admin/AdministracionProtocolos";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faRobot,
  faXmark,
  faPersonBooth,
  faMapLocation,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
import { useBot } from "../hooks/test/useBot";
import { HeaderTitle } from "../components/customComponents/Headers/HeaderTitle";
import { SidebarNotifica } from "../components/customComponents/Sidebar/SidebarNotifica";
import Card from "react-bootstrap/Card";
import moment from "moment";
import "moment/locale/es-mx";
import unidadenruta2 from "./../assets/img/icons/unidad-en-ruta2.png";
import desvioruta2 from "./../assets/img/icons/desvio-ruta2.png";
import endescarga2 from "./../assets/img/icons/en-descarga2.png";
import descargando2 from "./../assets/img/icons/descargando2.png";
import enesperadepocito2 from "./../assets/img/icons/en-espera-depocito2.png";
import enesperadefolios2 from "./../assets/img/icons/en-espera-folios2.png";
import consinmercancia2 from "./../assets/img/icons/con-sin-mercancia2.png";
import viajecancelado2 from "./../assets/img/icons/viaje-cancelado2.png";
import camionparado2 from "./../assets/img/icons/camion-parado2.png";
import viajeterminado2 from "./../assets/img/icons/viaje-terminado2.png";
import unidadguardada2 from "./../assets/img/icons/unidad-guardada2.png";
import enesperadesposito from "./../assets/img/icons/en-espera-desposito.png";

import { SocketContext } from "../context/SocketContext";
import { ProgramarRuta } from "../pages/landing/ProgramarRuta";
import { ReporteProductividad } from "../pages/Admin/ReporteProductividad";
import { ReporteProductividadXUsuario } from "../pages/Admin/ReporteProductividadXUsuario";
import { SwatRegistrosBoletinados } from "../pages/Admin/SwatRegistrosBoletinados";
import { useUnidades } from "../hooks/test/useUnidades";
import { formatDate } from "../helpers/formatDate";
import { ViajesEnRuta } from "../components/programarRuta/ViajesEnRuta";
import { ContingenciaAperturas } from "../pages/Admin/ContingenciaAperturas";
import { ReporteViajes } from "../pages/Admin/ReporteViajes";
import { EventosSeguridad } from "../pages/landing/EventosSeguridad";
import { ReporteEventosSeguridad } from "../pages/Admin/ReporteEventosSeguridad";
import { SessionUsuarios } from "../pages/Admin/SessionUsuarios";
import { TableroClientes } from "../pages/Admin/TableroClientes";
import { AdministracionUnidades } from "../pages/Admin/AdministracionUnidades";
import { UnidadesAutos } from "../pages/landing/UnidadesAutos";
import { UnidadesMotos } from "../pages/landing/UnidadesMotos";
import { NotificacionEventosRobo } from "../components/customComponents/Modals/NotificacionEventosRobo";
import { GestionDeReportes } from "../pages/Admin/GestionDeReportes";
import { DashboardSeguridad } from "../pages/Swat/Dashboard";
import { ToastContainer } from "react-toastify";
import { AdministracionMdvrs } from "../pages/Admin/AdministracionMdvrs";
import { CheckListCamaras } from "../pages/Admin/CheckListCamaras";
import { UnidadesCamiones } from "../pages/landing/UnidadesCamiones";

export const DashboardRoutes = () => {
  const { getNotificacionesBot } = useBot();
  const { user } = useContext(AuthContext);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const location = useLocation();
  const [lastLocation, setLastLocation] = useState("/");
  const [notificaciones, setNotificaciones] = useState();
  const [clicnotificaciones, setClicNotificaciones] = useState(false);
  const [denegadas, setDenegadas] = useState([]);
  const [completadas, setCompletadas] = useState([]);
  const [noEjecutado, setNoEjecutado] = useState([]);
  const { socket } = useContext(SocketContext);
  const [showModalGeneral, setShowModalGeneral] = useState(false);
  const [coordenadasporUnidad, setCoordenadasporUnidad] = useState([]);
  const demoFancyMapStyles = require("../components/jsonstyleMap/demoFancyMapStyles.json");
  const [ultimoestatusunidad, setultimoestatusunidad] = useState([]);
  const [registroSeguridadEventos, setRegistroSeguridadEventos] = useState([]);
  const { getUnidadesDinamicas, getRegistroSeguridadEventos } = useUnidades();

  const RedirectToIndex = () => {
    return <Navigate to="/login"></Navigate>;
  };

  useEffect(() => {
    if (loadData) {
      loadData();
    }
  }, []);

  useEffect(() => {
    if (!socket) return;
    socket.on("Evento_del_bot_para_teleapp", () => {
      loadNotificaciones();
    });

    socket.on("new_event_robo_", async () => {
      console.log("new event robo actualizando notificaciones");
      if (user.rol === "S.W.A.T") {
        let r = await getRegistroSeguridadEventos(true);
        if (r.ok) {
          setRegistroSeguridadEventos(r.data);
        }
      }
    });

    if (user.rol == "Administrador de cedis") {
      socket.emit("encargado_staffing");
      console.log("emit sokect encargado_staffing");
    }
    return () => {
      socket.off("new_event_robo_");
      socket.off("Evento_del_bot_para_teleapp");
    };
  }, [socket]);

  const loadNotificaciones = async () => {
    let resp = await getNotificacionesBot(user.negocio_id, 1);
    if (!resp.ok) return;
    setNotificaciones(resp);
  };

  useEffect(() => {
    if (user.rol !== "Monitorista") loadNotificaciones();
    const arrLength = (user.cedis || []).length;
    if (user.rol === "Monitorista" && arrLength === 0) {
      setLastLocation(location.pathname);
      return navigate("/select-cedis");
    }
    if (
      location.pathname === "/select-cedis" &&
      location.pathname !== lastLocation
    ) {
      navigate(lastLocation);
    }
  }, [user.cedis]);
  // if (pathname === "/" && (user.rol === "Administrador" || user.rol === "Monitorista"))
  //   return <Navigate to="/programar-salida"></Navigate>;
  // if (pathname === "/" && user.rol === "Administrador de cedis")
  //   return <Navigate to="/programar-ruta"></Navigate>;
  // if (pathname === "/" && user.rol === "S.W.A.T")
  //   return <Route exact path="/tablero" element={<Tablero />} />;
  // console.log("user", user);

  const loadData = async () => {
    // let resp = await getUnidadesDinamicas();
    // if (resp.ok) {
    //   setultimoestatusunidad([resp.bitacoras]);
    // }
    if (user.rol === "S.W.A.T") {
      let r = await getRegistroSeguridadEventos(true);
      if (r.ok) {
        setRegistroSeguridadEventos(r.data);
      }
    }
  };

  // const mostrarUnidad = () => {
  //   setShowModalGeneral(true)

  //   ultimoestatusunidad.map((bitacora) => {

  //     let points = [];
  //     for (let j = 0; j < bitacora.length; j++) {

  //       for (let i = 0; i < bitacora[j].bitacoras.length; i++) {

  //         if (bitacora[j].bitacoras.length-1 === i){

  //           const latA = bitacora[j].bitacoras[i].latitud;
  //           const lngA = bitacora[j].bitacoras[i].longuitud;
  //           const status = bitacora[j].bitacoras[i].id_status;
  //           const textstatus = bitacora[j].bitacoras[i].estatus;
  //           const color = bitacora[j].bitacoras[i].color;
  //           const icon = bitacora[j].bitacoras[i].icon;
  //           const fecharuta = bitacora[j].bitacoras[i].bitacora_fecha_hora;
  //           // const idUnidad = unidad_id;
  //           // const idViaje = id_viaje;
  //           points.push(
  //             {
  //               lat: latA,
  //               lng: lngA,
  //               status: status,
  //               color: color,
  //               icon: icon,
  //               textstatus: textstatus,
  //               fecharuta: fecharuta,
  //               idUnidad: bitacora[j].unidad_id,
  //               idViaje: bitacora[j].id_viaje,
  //             }
  //           );

  //         }
  //         setCoordenadasporUnidad(...[points]);
  //       }

  //     }

  //   });

  //   // var points = [
  //   //   { lat: 19.30444856754801, lng: -99.19064742661894 },
  //   //   { lat: 19.304245291991787, lng: -99.18613870408213 },
  //   //   { lat: 19.34435194140197, lng: -99.14044089429125 },
  //   //   { lat: 19.381724693776736, lng: -99.13998218186744 },
  //   //   { lat: 19.387685891812275, lng: -99.07410561187471 }
  //   // ];

  //   // setCoordenadasporUnidad(points);

  // }

  // const MyMapComponent = withScriptjs(withGoogleMap((props) =>

  //   <GoogleMap
  //     defaultZoom={11}
  //     defaultCenter={
  //       props.center? props.center :
  //       { lat: 19.43345222482108 , lng: -99.13396336665649 }
  //     }
  //     defaultOptions={{ styles: demoFancyMapStyles }}
  //   >
  //     {
  //       props.isMarkerShown && coordenadasporUnidad.map(({ lat, lng, idUnidad, icon, textstatus, fecharuta }, i) => (
  //         lat && lng?
  //           // <Marker
  //           //     position={{ lat, lng }}
  //           //     key={i}
  //           //     icon = {{
  //           //       path: faTruck.icon[4],
  //           //       fillColor:  "#DDE929",
  //           //       fillOpacity: 1,
  //           //       strokeWeight: 1,
  //           //       strokeColor: "#000",
  //           //       scale: 0.045,
  //           //     } }
  //           // />
  //           <Marker
  //               position={{ lat, lng }}
  //               key={i}
  //               icon={
  //                 icon === "fa-solid fa-truck-arrow-right" ?
  //                   desvioruta2
  //                 :
  //                 icon === "fas fa-dolly" ?
  //                   endescarga2
  //                 :
  //                 icon === "far fa-arrow-alt-circle-down" ?
  //                   descargando2
  //                 :
  //                 icon === "fa fa-battery-full" ?
  //                   enesperadepocito2
  //                 :
  //                 icon === "fa-regular fa-folder-open" ?
  //                   enesperadefolios2
  //                 :
  //                 icon === "fas fa-shuttle-van" ?
  //                   consinmercancia2
  //                 :
  //                 icon === "fa-solid fa-stop" ?
  //                   camionparado2
  //                 :
  //                 icon === "fas fa-ban" ?
  //                   viajecancelado2
  //                 :
  //                 icon === "fa-solid fa-truck-front" ?
  //                   unidadguardada2
  //                 :
  //                 icon === "fa-solid fa-flag-checkered" ?
  //                   viajeterminado2
  //                 :
  //                 icon === "fa-solid fa-truck-fast" ?
  //                   unidadenruta2
  //                 :
  //                 icon === "fa fa-tag" ?
  //                   enesperadesposito
  //                 :""
  //               }
  //               defaultTitle = {idUnidad + " " +textstatus + " " +  formatDate(fecharuta) }
  //           />
  //         : ""
  //       ))
  //     }

  //   </GoogleMap>
  // ))

  return (
    <>
      {pathname !== "/select-cedis" && <Navbar />}

      <div className="pt-5 mt-4">
        <Routes>
          {user.rol === "Monitorista" ? (
            <Route exact path="/select-cedis" element={<SelectCedis />} />
          ) : (
            RedirectToIndex
          )}
          {user.roles_id === 6 ? (
            <Route exact path="/tablero" element={<Tablero />} />
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.programarRuta ? (
            <>
              <Route exact path="/programar-ruta" element={<ProgramarRuta />} />

              <Route exact path="/viajes-ruta" element={<ViajesEnRuta />} />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.programarSalida ? (
            <Route
              exact
              path="/programar-salida"
              element={<ProgramarSalida />}
            />
          ) : (
            RedirectToIndex
          )}

          {user.permisosMenu.enRuta ? (
            <Route exact path="/enRuta" element={<EnRuta />} />
          ) : (
            RedirectToIndex
          )}

          {user.permisosMenu.bitacora ? (
            <>
              <Route exact path="/bitacora" element={<Bitacora />} />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.generacionCodigos ? (
            <>
              <Route exact path="/generacionCodigos" element={<GeneracionCodigos />} />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.tablero ? (
            <>
              <Route exact path="/tablero" element={<Tablero />} />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.administracionViajes ? (
            <>
              <Route
                exact
                path="/edicion-viaje"
                element={<AdministracionEdicionViajes></AdministracionEdicionViajes>}
              />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.autos ? (
            <>
              <Route exact path="/autos" element={<UnidadesAutos />} />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.motos ? (
            <>
              <Route exact path="/motos" element={<UnidadesMotos />} />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.camiones ? (
            <>
              <Route exact path="/camiones" element={<UnidadesCamiones />} />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.administracionUidades ? (
            <>
              <Route exact path="/admin-unidades" element={<AdministracionUnidades />} />
            </>
          ) : (
            RedirectToIndex
          )}
          {/* {user.permisosMenu.contingencia ? (
            <Route
              exact
              path="/tablero-contingencia"
              element={<ContingenciaAperturas></ContingenciaAperturas>}
            />
          ) : (
            RedirectToIndex
          )} */}
          {user.permisosMenu.eventosDeSeguridad ? (
            <>
              <Route
                exact
                path="/eventos-de-seguridad"
                element={<EventosSeguridad />}
              />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.reporteEventosDeSeguridad ? (
            <>
              <Route
                exact
                path="/reporte-eventos-de-seguridad"
                element={<ReporteEventosSeguridad />}
              />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.boletinados ? (
            <>
              <Route
                exact
                path="/eventos-boletinados"
                element={<SwatRegistrosBoletinados />}
              />
              <Route
                exact
                path="/dashboard-cad"
                element={<DashboardSeguridad />}
              />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.gestionDeReportes ? (
            <>
              <Route
                exact
                path="/gestion-reportes"
                element={<GestionDeReportes />}
              />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.tableroAdministracion ? (
            <>
              <Route
                exact
                path="/tablero-gerencial"
                element={<TableroGerencial />}
              />
            </>
          ) : (
            RedirectToIndex
          )}
          {user.permisosMenu.admin || user.permisosMenu.SU ? (
            <>
              {user.negocio_id === 1 ||
                user.negocio_id === "1" ||
                user.negocio_id === 2 ||
                user.negocio_id === "2" ? (
                <>
                  <Route
                    exact
                    path="/bitacora-administracion"
                    element={<BitacoraAdministracion />}
                  />
                </>
              ) : (
                " "
              )}
              <Route exact path="/notificaciones-log" element={<Historico />} />
              {user.negocio_id === 1 ||
                user.negocio_id === "1" ||
                user.negocio_id === 2 ||
                user.negocio_id === "2" ? (
                <>
                  <Route
                    exact
                    path="/tablero-clientes"
                    element={<TableroClientes></TableroClientes>}
                  />
                </>
              ) : (
                " "
              )}
              <Route
                exact
                path="/tablero-usuarios"
                element={<TableroUsuarios></TableroUsuarios>}
              />
              <Route
                exact
                path="/tablero-tripulantes"
                element={<TableroTripulantes />}
              />
              <Route
                exact
                path="/tablero-tiendas"
                element={<TableroTiendas></TableroTiendas>}
              />
              <Route
                exact
                path="/tablero-cedis"
                element={<TableroCedis></TableroCedis>}
              />
              <Route
                exact
                path="/tablero-unidades"
                element={<TableroUnidades></TableroUnidades>}
              />
              {user.negocio_id === 1 ||
                user.negocio_id === "1" ||
                user.negocio_id === 2 ||
                user.negocio_id === "2" ? (
                <>
                  <Route
                    exact
                    path="/tablero-staffing"
                    element={<Staffing></Staffing>}
                  />
                  <Route
                    exact
                    path="/tablero-session-usuarios"
                    element={<SessionUsuarios></SessionUsuarios>}
                  />
                  <Route
                    exact
                    path="/tablero-productivity"
                    element={<ReporteProductividad></ReporteProductividad>}
                  />
                  <Route
                    exact
                    path="/tablero-productivity-user"
                    element={
                      <ReporteProductividadXUsuario></ReporteProductividadXUsuario>
                    }
                  />
                  <Route
                    exact
                    path="/tablero-reporte-viajes"
                    element={<ReporteViajes></ReporteViajes>}
                  />
                  <Route
                    exact
                    path="/mdvrs"
                    element={<AdministracionMdvrs></AdministracionMdvrs>}
                  />
                  <Route
                    exact
                    path="/camaras"
                    element={<CheckListCamaras></CheckListCamaras>}
                  />
                </>
              ) : (
                " "
              )}
              <Route
                exact
                path="/tablero-contingencia"
                element={<ContingenciaAperturas></ContingenciaAperturas>}
              />
              <Route
                exact
                path="/tablero-status-enRutas"
                element={<AdministracionStatusEnRuta></AdministracionStatusEnRuta>}
              />
              <Route
                exact
                path="/edicion-viaje"
                element={<AdministracionEdicionViajes></AdministracionEdicionViajes>}
              />
              <Route
                exact
                path="/protocolos"
                element={<AdministracionProtocolos></AdministracionProtocolos>}
              />
            </>
          ) : (
            RedirectToIndex
          )}

          {/* <Route exact path="/" element={(user.roles_id === 1 ||  user.roles_id === 2) ? <ProgramarSalida /> : user.roles_id === 4 ? <ProgramarRuta /> : <Tablero /> } /> */}
          <Route exact path="/test" element={<Test />} />
          <Route path="/" element={<Navigate to={(user.roles_id === 1 || user.roles_id === 2) ? "programar-salida" : user.roles_id === 4 ? "programar-ruta" : "tablero"} />} />
          <Route exact path={pathname} element={<RutaNoExistente />} />
        </Routes>
      </div>

      {pathname !== "/select-cedis" &&
        user.negocio_id &&
        user.rol !== "Administrador de cedis" &&
        user.rol !== "Monitorista" && (
          <>
            <WhatsappBotNotification></WhatsappBotNotification>
            <i
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
              className="notification m-3"
              onClick={() => {
                console.log("clic notificaciones");
                setClicNotificaciones(true);
              }}
              style={{ zIndex: "999" }}
            // id="vertical-menu-wrapper-add"
            >
              <FontAwesomeIcon icon={user.rol === "S.W.A.T" ? faBell : faRobot} />
              <span className="badge badge-light">
                {notificaciones ? notificaciones.denegadas : ""}
              </span>
            </i>
          </>
        )}
      {user.rol === "S.W.A.T" ? (<NotificacionEventosRobo registroSeguridadEventos={registroSeguridadEventos} />) : ("")}
      {
        // pathname !== "/select-cedis" &&
        // user.negocio_id === 2 &&
        // user.rol !== "Administrador de cedis" && (
        //   <>
        //     <i
        //       className="m-3 mostrarUnidades"
        //       onClick={ mostrarUnidad }
        //     >
        //       <FontAwesomeIcon icon={faMapLocation} />
        //     </i>
        //   </>
        // )
      }
      <div
        className="offcanvas offcanvas-end"
        data-bs-backdrop="false"
        data-bs-scroll="true"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
        style={{ zIndex: "999" }}
      >
        <div>
          <HeaderTitle className="card-header" id="card-header">
            Notificaciones{"    "}
            {/* <b style={{ color: "#ffcd00" }}>({denegadas.length})</b> */}
            <span
              title="Solicitudes"
              className="badge rounded-pill bg-secondary"
            >
              {notificaciones && (notificaciones.total > 999) ? "+999" : notificaciones ? notificaciones.total : ""}
              <i className="fa-solid fa-truck-ramp-box"></i>
            </span>
            {"    "}
            <span title="Completadas" className="badge rounded-pill bg-success">
              {notificaciones && (notificaciones.completadas > 999) ? "+999" : notificaciones ? notificaciones.completadas : ""}
              <i className="fa-solid fa-check-double"></i>
            </span>
            {"    "}
            <span
              title={`Denegadas: ${notificaciones ? notificaciones.denegadas : ""}`}
              className="badge rounded-pill bg-danger"
            >
              {notificaciones && notificaciones.denegadas > 999
                ? "+999"
                : notificaciones ? notificaciones.denegadas : ""}
              <i className="fa-solid fa-ban"></i>
            </span>
            <i
              type="button"
              className="icono-cerrar p-2"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <FontAwesomeIcon icon={faXmark} />
            </i>
          </HeaderTitle>
        </div>
        <div className="offcanvas-body">
          {
            clicnotificaciones ? (
              <SidebarNotifica />
            ) : ""
          }
        </div>
      </div>
      {
        user.roles_id != 1 && user.roles_id != 7 && <ToastContainer />
      }

      {/* {showModalGeneral && (
        <Modal
          show={showModalGeneral}
          onHide={() => setShowModalGeneral(false)}
          id="modal-100"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Unidades en ruta
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: 0}}>

            <MyMapComponent 
              isMarkerShown
              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBZhFRVYMBem1Uzyq7YMQsrozbvwGN5j_4&libraries=drawing&libraries=geometry"
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={<div style={{ height: `660px` }} />}
              mapElement={<div style={{ height: `100%` }} />}
            />

          </Modal.Body>
        </Modal>
      )} */}
    </>
  );
};
